import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXCardModal from "../../../../Components/Modals/BMXCardModal/BMXCardModal";
import DictionaryValueForm from "../../Forms/Admin/DictionaryValueForm/DictionaryValueForm";

const DictionaryValueModal = (props) => {
  const { handleHide, show, clientX, clientY, header } = props;
  const { t } = useTranslation();
 
  return (
    <BMXCardModal
      left={clientX}
      top={clientY}
      height="max-content"
      width={"500px"}
      header={header||t("global:addDictionaryValue")}
      open={show}
      onClose={handleHide}
    >
      <DictionaryValueForm {...props}/>
    </BMXCardModal>
  );
};

export default connectModal({ name: "DictionaryValueModal" })(DictionaryValueModal);